
  <input type="{{type}}" class="{{class}}" id="{{name}}" [formControl]="control" mask="{{mask}}"
    maxlength="{{maxLength}}" minlength="{{minLength}}" placeholder="{{placeholder}}" required="{{required}}"
    [class.is-invalid]="control?.dirty && required && control?.invalid">
